export default "__VITE_ASSET__4d7fa2dd__"